export default __webpack_public_path__ + "static/modalImage-d97c41bb6b462458f5b77a90a1e90c57.png";